import { createRouter as _createRouter, createWebHistory, Router } from 'vue-router'
import { Config } from '@/config/types'

const createRouter = (_config: Config): Router => {
  return _createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: [
      {
        path: '/:bookingId/proposal',
        name: 'Preview',
        components: {
          main: () => import('@/components/Wave.vue'),
        },
        props: {
          main: (route) => ({
            type: route.params.type,
            bookingId: decodeURIComponent(route.params.bookingId.toString()),
            isAdded: false,
          }),
        },
      },
    ],
  })
}

export default createRouter
